import { render, staticRenderFns } from "./pageElement.vue?vue&type=template&id=a7238cf0&scoped=true"
import script from "./pageElement.vue?vue&type=script&lang=js"
export * from "./pageElement.vue?vue&type=script&lang=js"
import style0 from "./pageElement.vue?vue&type=style&index=0&id=a7238cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7238cf0",
  null
  
)

export default component.exports